import { api } from './http';

export type SupportCategory =
  | 'access'
  | 'flights'
  | 'maintenance'
  | 'finance'
  | 'bookings'
  | 'other';

export type SupportStatus = 'open' | 'answered' | 'resolved';

export type SupportMessage = {
  id: number;
  is_from_support: boolean;
  body: string;
  created_at: string;
};

export type SupportTicket = {
  id: number;
  club_name: string | null;
  category: SupportCategory;
  subject: string;
  status: SupportStatus;
  platform: string | null;
  app_version: string | null;
  screen: string | null;
  aircraft_tail: string | null;
  created_at: string;
  updated_at: string;
  resolved_at: string | null;
  unread: boolean;
  /** Оценка автора 1–5, только у решённого обращения */
  rating: number | null;
  rated_at: string | null;
  /** Только в ответах для аккаунта поддержки */
  author?: { id: number; login: string; name: string };
  messages?: SupportMessage[];
};

export type CreateSupportTicketData = {
  category: SupportCategory;
  subject: string;
  body: string;
  platform: 'web';
  app_version: string;
  screen?: string;
  aircraft_tail?: string;
};

export const getSupportTickets = (status?: SupportStatus) =>
  api
    .get<SupportTicket[]>('/support/tickets', {
      params: status ? { status } : undefined,
    })
    .then((res) => res.data);

export const getSupportTicket = (ticketId: number) =>
  api.get<SupportTicket>(`/support/tickets/${ticketId}`).then((res) => res.data);

export const createSupportTicket = (data: CreateSupportTicketData) =>
  api.post<SupportTicket>('/support/tickets', data).then((res) => res.data);

export const sendSupportMessage = (ticketId: number, body: string) =>
  api
    .post<SupportTicket>(`/support/tickets/${ticketId}/messages`, { body })
    .then((res) => res.data);

export const resolveSupportTicket = (ticketId: number) =>
  api
    .put<SupportTicket>(`/support/tickets/${ticketId}/resolve`)
    .then((res) => res.data);

export const rateSupportTicket = (ticketId: number, rating: number) =>
  api
    .put<SupportTicket>(`/support/tickets/${ticketId}/rating`, { rating })
    .then((res) => res.data);

export const getSupportUnreadCount = () =>
  api
    .get<{ count: number }>('/support/unread-count')
    .then((res) => res.data.count);
